import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import classes from './DropFiles.module.scss';

const DropFiles = ({ className, children, onDroppedFiles, name, typeFile, maxFiles, maxSize, disabled }) => {
  const onDrop = useCallback(onDroppedFiles, [onDroppedFiles]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled: disabled,
    ...(typeFile && { accept: { ...typeFile } }),
    ...(maxFiles && { maxFiles }),
    ...(maxSize && { maxSize })
  });

  let key = 'dropFile';
  if (name) {
    key = name;
  }
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div className={containerClasses.join(' ')} {...getRootProps()}>
      <input name={key} {...getInputProps()} />
      {children}
      {isDragActive && (
        <div className={classes['drag-active']}>
          <span className='medium-18'>Suelta acá los archivos</span>
        </div>
      )}
    </div>
  );
};

export default DropFiles;
